import React from "react";

export const Background: React.FC<{
  children?: React.ReactNode;
}> = (props) => {
  return (
    <div
      style={{
        backgroundColor: "#fefefe",
      }}
    >
      {props.children}
    </div>
  );
};
